class EfdAlertas {
    static get $inject() {
        return ['$scope', 'gql']
    }

    constructor($scope, gql) {
        this.apply = fn => $scope.$apply(fn)
        this.gql = gql
        this.filter = {}
        this.documentoFilter = { tipo: 'nfe' }
        this.participanteFilter = {}

        $scope.$watch(() => this.documentoFilter, (newValue) => {
            if (newValue.tipo == 'notaFiscal')
                this.participanteFilter = {}

            if (newValue.numero || newValue.chave) {
                this.collapseStates[this.filter.tipoIs] = true
                delete this.filter.tipoIs

                this.refresh()
            }
        }, true)

        $scope.$watch(() => this.participanteFilter, () => { this.refreshFilteredAlertasCount() }, true)
        $scope.$watch(() => this.filter.tipoIs, (newValue) => { newValue && this.refresh() }, true)

        this.tiposAlertas = [
            { tipo: 'NFE_RECEBIDA_AUSENTE', descricao: 'NF-e recebida ausente na EFD.', grupo: 'nfe', tipoEfd: 'ICMS' },
            { tipo: 'NFE_EMITIDA_AUSENTE', descricao: 'NF-e emitida ausente na EFD.', grupo: 'nfe', tipoEfd: 'ICMS' },
            { tipo: 'NFE_RECEBIDA_AUSENTE_NO_EF', descricao: 'NF-e recebida ausente no Eficiência Fiscal.', grupo: 'nfe', tipoEfd: 'ICMS' },
            { tipo: 'NFE_EMITIDA_AUSENTE_NO_EF', descricao: 'NF-e emitida ausente no Eficiência Fiscal.', grupo: 'nfe', tipoEfd: 'ICMS' },
            { tipo: 'NFE_PARTICIPANTE_DIVERGENTE', descricao: 'NF-e possui participante divergente ao informado na EFD.', grupo: 'nfe', tipoEfd: 'ALL' },
            { tipo: 'NFE_CFOP_CST_INCORRETO', descricao: 'NF-e com CFOP ou CST inconsistente.', grupo: 'nfe', tipoEfd: 'ICMS' },
            { tipo: 'NFE_DADOS_DIVERGENTES', descricao: 'NF-e possui dados divergentes ao informado na EFD.', grupo: 'nfe', tipoEfd: 'ALL' },
            { tipo: 'NFE_ITEM_DADOS_DIVERGENTES', descricao: 'NF-e possui alíquotas divergentes ao informado na EFD.', grupo: 'nfe', tipoEfd: 'ALL' },
            { tipo: 'NFE_ITEM_VALOR_ICMS_DIVERGENTE', descricao: 'Crédito ICMS no EFD diferente do destacado na NF-e.', grupo: 'nfe', tipoEfd: 'ALL' },
            { tipo: 'NFE_DUPLICADA', descricao: 'Lançamento duplicado de NF-e.', grupo: 'nfe', tipoEfd: 'ALL' },
            { tipo: 'NFE_CANCELADA', descricao: 'Lançamento de cancelamento não identificado.', grupo: 'nfe', tipoEfd: 'ALL' },
            { tipo: 'CTE_FOB_AUSENTE', descricao: 'CT-e FOB não informado na EFD.', grupo: 'cte', tipoEfd: 'ALL' },
            { tipo: 'REGISTRO_SERVICOS_BASICOS_AUSENTE', descricao: 'Registro de serviços básicos ausente na EFD.', grupo: 'efd', tipoEfd: 'ALL' },
            { tipo: 'REGISTRO_IMOBILIZADO_AUSENTE', descricao: 'Registro de imobilizado ausente na EFD.', grupo: 'efd', tipoEfd: 'PIS_COFINS' },
        ]

        this.collapseStates = {
            'NFE_RECEBIDA_AUSENTE': true,
            'NFE_EMITIDA_AUSENTE': true,
            'NFE_RECEBIDA_AUSENTE_NO_EF': true,
            'NFE_EMITIDA_AUSENTE_NO_EF': true,
            'NFE_PARTICIPANTE_DIVERGENTE': true,
            'NFE_CFOP_CST_INCORRETO': true,
            'NFE_DADOS_DIVERGENTES': true,
            'NFE_ITEM_DADOS_DIVERGENTES': true,
            'NFE_ITEM_VALOR_ICMS_DIVERGENTE': true,
            'NFE_DUPLICADA': true,
            'NFE_CANCELADA': true,
            'CTE_FOB_AUSENTE': true,
        }
    }

    static get nfeFields() {
        return `
            id
            chave
            numero
            emissao
            emissaoPropria
        `
    }

    static get cteFields() {
        return `
            id
            chave
            numero
            emissao
            emitente {
                id
                nome: razaoSocial
                cpfCnpj
            }
        `
    }

    static get participanteFields() {
        return `
            id
            nome
            cpfCnpj
        `
    }

    get tipoAlertaFilterOptions() {
        return this.efd && this.tiposAlertas
            .filter(tipoAlerta => tipoAlerta.grupo !== 'efd' && (tipoAlerta.tipoEfd == 'ALL' || tipoAlerta.tipoEfd == this.efd.tipo))
    }

    get tiposAlertasGrupoEfd() {
        return this.efd && this.tiposAlertas
            .filter(tipoAlerta => tipoAlerta.grupo === 'efd' && (tipoAlerta.tipoEfd == 'ALL' || tipoAlerta.tipoEfd == this.efd.tipo))
    }

    $onInit() {
        this.initialPromise = this.loadEfdAlertasCount()
            .then(({ alertasCount, efd, produtosContratados }) => {
                this.alertasCount = alertasCount

                this.alertasFilter = Array
                    .from(this.alertasCount.keys())
                    .reject((alerta) => alerta == "REGISTRO_SERVICOS_BASICOS_AUSENTE" || alerta == "REGISTRO_IMOBILIZADO_AUSENTE")

                this.isAlertasEfdEnabled = produtosContratados.includes('alertas-efd')
                this.efd = efd
            })
            .finally(() => this.apply())
    }

    pageChange(page) {
        return this.refresh(page)
    }

    refresh(page = {}) {
        let filter = { tipoIs: this.filter.tipoIs }

        for (let key in filter) if (filter.hasOwnProperty(key) && (filter[key] === undefined || filter[key] === "")) {
            delete filter[key]
        }

        if (this.documentoFilter.numero || this.documentoFilter.chave) {
            const key = this.documentoFilter.numero ? 'NumeroIs' : 'ChaveIs'
            filter[this.documentoFilter.tipo + key] = (this.documentoFilter.numero || this.documentoFilter.chave).replace(/\D/g, '')
        }

        this.filterBuscaParticipante(filter)

        this.filter = filter

        this.alertasPromise = this.loadEfdAlertas(page)
            .then(({ alertas, after, before }) => {
                if (page.after) {
                    this.currentPage = this.currentPage + 1
                }

                if (page.before) {
                    this.currentPage = this.currentPage - 1
                }

                if (!page.before && !page.after) {
                    this.currentPage = 1
                    this.searchContext = new Date()
                }

                this.alertas = alertas
                this.alertasList = alertas.groupBy((a) => a.tipo)

                this.nextPage = after
                this.previousPage = before
            })
            .finally(() => this.apply())
    }

    refreshAlertasCount() {
        this.alertasCountPromise = this.loadEfdAlertasCount()
            .then(({ alertasCount, efd }) => {
                this.alertasCount = alertasCount
                this.efd = efd
            })
            .catch(console.error)
            .finally(() => this.apply())
    }

    filterBuscaParticipante(filter) {
        if (this.participanteFilter.busca) {
            const busca = this.participanteFilter.busca
                .replace(/(\d{3})\.(\d{3})\.(\d{3})-(\d{2})/g, "$1$2$3$4")
                .replace(/(\d{2})\.(\d{3})\.(\d{3})\/(\d{4})-(\d{2})/g, "$1$2$3$4$5")

            filter[this.documentoFilter.tipo + this.participanteFilter.tipo.capitalize() + 'Contains'] = busca
            this.participanteFilter.busca = busca
        }
    }

    refreshFilteredAlertasCount() {
        const filter = {}

        this.filterBuscaParticipante(filter)

        this.alertasCountPromise = this.loadEfdAlertasCount(filter)
            .then(({ alertasCount }) => {
                this.alertasFilteredCount = Array
                    .from(alertasCount.keys())
                    .reject((alerta) => alerta == "REGISTRO_SERVICOS_BASICOS_AUSENTE" || alerta == "REGISTRO_IMOBILIZADO_AUSENTE")
            })
            .catch(console.error)
            .finally(() => this.apply())

        this.refresh()
    }

    loadEfdAlertasCount(filter = {}) {
        const query = gql`
            query EfdAlertasCount($filialId: Int!, $efdId: Int!, $alertasFilter: EfdAlertaFilter) {
                filial(id: $filialId) {
                    id
                    efd(id: $efdId) {
                        id
                        tipo
                        alertasCount(filter: $alertasFilter) {
                            tipo
                            quantidade
                        }
                    }
                    produtosContratados: ferramentasContratadas
                }
            }
        `

        return this.gql
            .query(query, { filialId: parseInt(this.filialId), efdId: parseInt(this.efdId), alertasFilter: filter })
            .then(({ filial: { efd, produtosContratados } }) => {
                return {
                    produtosContratados,
                    alertasCount: new Map(efd.alertasCount.map(({ tipo, quantidade }) => [tipo, quantidade])),
                    efd
                }
            })
    }

    loadEfdAlertas(page) {
        const query = gql`
            query ListEfdAlertas($filialId: Int!, $efdId: Int!, $filter: EfdAlertaFilter, $after: String, $before: String, $limit: Int!) {
                filial(id: $filialId) {
                    id
                    efd(id: $efdId) {
                        id
                        alertas: alertasPage(filter: $filter, after: $after, before: $before, limit: $limit) {
                            after
                            before
                            entries {
                                ... on EfdAlerta {
                                    id
                                    tipo
                                    nfeCfopCstIncorreto {
                                        nfe {
                                            ${EfdAlertas.nfeFields}
                                            emitente {
                                                ${EfdAlertas.participanteFields}
                                            }
                                        }
                                        notaFiscal {
                                            ${EfdAlertas.nfeFields}
                                        }
                                        sugestoes {
                                            id
                                            cfop
                                            csts
                                            csosns
                                            nfeItem {
                                                id
                                                codigo
                                                cfop
                                            }
                                            notaFiscalItem {
                                                id
                                                codigo
                                                cfop
                                                cstIcms
                                            }
                                        }
                                    }
                                    nfeDadosDivergentes {
                                        nfe {
                                            ${EfdAlertas.nfeFields}
                                            emitente {
                                                ${EfdAlertas.participanteFields}
                                            }
                                        }
                                        notaFiscal {
                                            ${EfdAlertas.nfeFields}
                                        }
                                        valorNfe
                                        valorEfd
                                        valorIcmsNfe
                                        valorIcmsEfd
                                    }
                                    nfeItemDadosDivergentes {
                                        nfe {
                                            ${EfdAlertas.nfeFields}
                                            emitente {
                                                ${EfdAlertas.participanteFields}
                                            }
                                        }
                                        notaFiscal {
                                            ${EfdAlertas.nfeFields}
                                            participante {
                                                ${EfdAlertas.participanteFields}
                                            }
                                        }
                                        itensDivergentes {
                                            id
                                            aliquotaIcms {
                                                valorItemNfe
                                                valorItemEfd
                                            }
                                            aliquotaPis {
                                                valorItemNfe
                                                valorItemEfd
                                            }
                                            aliquotaCofins {
                                                valorItemNfe
                                                valorItemEfd
                                            }
                                            nfeItem {
                                                codigo
                                                descricao
                                                id
                                            }
                                            notaFiscalItem {
                                                id
                                            }
                                        }
                                    }
                                    nfeItemValorIcmsDivergente {
                                        valorTotalIcmsNfe
                                        valorTotalIcmsEfd
                                        nfe {
                                            ${EfdAlertas.nfeFields}
                                            emitente {
                                                ${EfdAlertas.participanteFields}
                                            }
                                        }
                                        notaFiscal {
                                            ${EfdAlertas.nfeFields}
                                            participante {
                                                ${EfdAlertas.participanteFields}
                                            }
                                        }
                                        itensIcmsDivergentes {
                                            id
                                            valorIcmsNfe
                                            valorIcmsEfd
                                            nfeItem {
                                                codigo
                                                descricao
                                                id
                                            }   
                                            notaFiscalItem {
                                                id
                                            }
                                        }
                                    }
                                    nfeEmitidaAusente {
                                        nfe {
                                            ${EfdAlertas.nfeFields}
                                            destinatario {
                                                ${EfdAlertas.participanteFields}
                                            }
                                        }
                                    }
                                    nfeEmitidaAusenteNoEf {
                                        notaFiscal {
                                            ${EfdAlertas.nfeFields}
                                            participante {
                                                ${EfdAlertas.participanteFields}
                                            }
                                        }
                                    }
                                    nfeRecebidaAusente {
                                        nfe {
                                            ${EfdAlertas.nfeFields}
                                            emitente {
                                                ${EfdAlertas.participanteFields}
                                            }
                                        }
                                    }
                                    nfeRecebidaAusenteNoEf {
                                        notaFiscal {
                                            ${EfdAlertas.nfeFields}
                                            participante {
                                                ${EfdAlertas.participanteFields}
                                            }
                                        }
                                    }
                                    nfeParticipanteDivergente {
                                        nfe {
                                            ${EfdAlertas.nfeFields}
                                        }
                                        notaFiscal {
                                            ${EfdAlertas.nfeFields}
                                        }
                                        participanteNfe {
                                            ${EfdAlertas.participanteFields}
                                        }
                                        participanteEfd {
                                            ${EfdAlertas.participanteFields}
                                        }
                                    }
                                    nfeCancelada {
                                        nfe {
                                            ${EfdAlertas.nfeFields}
                                        }
                                        notaFiscal {
                                            ${EfdAlertas.nfeFields}
                                            efd {
                                                id
                                                tipo
                                                dataReferencia
                                            }
                                            participante {
                                                ${EfdAlertas.participanteFields}
                                            }
                                        }
                                    }
                                    nfeDuplicada { 
                                        notaFiscalOriginal {
                                            ${EfdAlertas.nfeFields}
                                            efd {
                                                id
                                                tipo
                                                dataReferencia
                                            }
                                            participante {
                                                ${EfdAlertas.participanteFields}
                                            }
                                        }
                                        notaFiscalDuplicada {
                                            ${EfdAlertas.nfeFields}
                                        }
                                    }
                                    cteFobAusente {
                                        cte {
                                            ${EfdAlertas.cteFields}
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        `

        const variables = {
            ...page,
            filialId: parseInt(this.filialId),
            efdId: parseInt(this.efdId),
            filter: this.filter,
            limit: 10
        }

        return this.gql
            .query(query, variables)
            .then(({ filial: { efd } }) => {
                const { after, before, entries } = efd.alertas

                const alertas = entries.map(alerta => {
                    if (alerta.tipo == 'NFE_CFOP_CST_INCORRETO') {
                        let sugestoes = alerta.nfeCfopCstIncorreto.sugestoes
                            .groupBy(({ nfeItem, notaFiscalItem }) =>
                                JSON.stringify({
                                    codigo: nfeItem.codigo,
                                    cfopEntrada: nfeItem.cfop,
                                    cfopSaida: notaFiscalItem.cfop,
                                    cstSaida: notaFiscalItem.cstIcms
                                })
                            )

                        sugestoes = Object.entries(sugestoes).map(([item, sugestoes]) => {
                            return {
                                item: JSON.parse(item),
                                sugestoes: sugestoes.map(({ cfop, csts, csosns }) =>
                                    ({ cfop, csts, csosns })
                                )
                            }
                        })
                        alerta.nfeCfopCstIncorreto.sugestoes = sugestoes
                    }

                    if (alerta.tipo == 'NFE_ITEM_DADOS_DIVERGENTES') {
                        let itensDivergentesIcms = alerta.nfeItemDadosDivergentes.itensDivergentes
                            .reject((a) => a.aliquotaIcms == null)
                            .groupBy(({ nfeItem, aliquotaIcms }) =>
                                JSON.stringify({
                                    codigo: nfeItem.codigo,
                                    descricao: nfeItem.descricao,
                                    aliquotaIcms: aliquotaIcms
                                })
                            )

                        let itensDivergentesPisCofins = alerta.nfeItemDadosDivergentes.itensDivergentes
                            .groupBy(({ nfeItem, aliquotaPis, aliquotaCofins }) =>
                                JSON.stringify({
                                    codigo: nfeItem.codigo,
                                    descricao: nfeItem.descricao,
                                    aliquotaPis: aliquotaPis,
                                    aliquotaCofins: aliquotaCofins
                                })
                            )

                        itensDivergentesIcms = Object.entries(itensDivergentesIcms).map(([item]) => {
                            return {
                                divergencia: JSON.parse(item)
                            }
                        })

                        itensDivergentesPisCofins = Object.entries(itensDivergentesPisCofins).map(([item]) => {
                            return {
                                divergencia: JSON.parse(item)
                            }
                        })

                        alerta.nfeItemDadosDivergentes.itensDivergentes = { itensDivergentesIcms, itensDivergentesPisCofins }
                    }

                    if (alerta.tipo == 'NFE_ITEM_VALOR_ICMS_DIVERGENTE') {
                        let itensDivergentesIcms = alerta.nfeItemValorIcmsDivergente.itensIcmsDivergentes
                            .groupBy(({ nfeItem, valorIcmsNfe, valorIcmsEfd }) =>
                                JSON.stringify({
                                    codigo: nfeItem.codigo,
                                    descricao: nfeItem.descricao,
                                    valorIcmsNfe: valorIcmsNfe,
                                    valorIcmsEfd: valorIcmsEfd
                                })
                            )

                        itensDivergentesIcms = Object.entries(itensDivergentesIcms).map(([item]) => {
                            return {
                                divergencia: JSON.parse(item)
                            }
                        })

                        alerta.nfeItemValorIcmsDivergente.itensIcmsDivergentes = itensDivergentesIcms
                    }

                    return alerta
                })
                return { alertas, after, before }
            })
    }
 
    getDescricaoTipoAlerta(tipo) {
        const tipoAlerta = this.tiposAlertas.find(tipoAlerta => tipoAlerta.tipo === tipo)

        return tipoAlerta && tipoAlerta.descricao
    }

    isEmpty(value) {
        return angular.equals(value, {});
    }

    switchAlerta(tipoIs, isCollapsed) {
        let filter = { ...this.filter, tipoIs }

        Object
            .keys(this.collapseStates)
            .forEach(key => {
                this.collapseStates[key] = key === tipoIs
                    ? isCollapsed
                    : true
            })

        this.filter = filter
    }
}

angular.module('eficienciaFiscalModule')
    .component('efdAlertas', {
        controller: EfdAlertas,
        bindings: {
            efdId: '<',
            filialId: '<'
        },
        template: `
            <div>
                <loading promise="$ctrl.initialPromise" active="isLoading">
                    <ef-permissao-ferramenta disabled="!$ctrl.isAlertasEfdEnabled" message="Este produto não foi contratado para a sua filial.">
                        <div class="well well-xs">
                            <promise-tracker promise="$ctrl.alertasCountPromise" active="isCountLoading">
                                <div class="alertas-count-header">      
                                    <h4>Alertas identificados</h4>
                                    <span 
                                        class="btn btn-link" 
                                        ng-click="$ctrl.refreshAlertasCount()">
                                        <i class="fa fa-refresh" ng-class="{'fa-spin': isCountLoading}"></i>
                                    </span>
                                    <span class="fade-animation" ng-if="isCountLoading">Atualizando...</span>
                                </div>
                                <div class="alertas-count">
                                    <div>    
                                        <a ng-repeat-start="tipoAlerta in $ctrl.tipoAlertaFilterOptions"
                                            class="btn btn-link alertas-link"
                                            ng-disabled="$ctrl.alertasCount.get(tipoAlerta.tipo) == null"
                                            href="javascript:void(0)" 
                                            ng-click="$ctrl.switchAlerta(tipoAlerta.tipo, false)">
                                            {{tipoAlerta.descricao}}    
                                        </a>
                                        <span ng-repeat-end>{{$ctrl.alertasCount.get(tipoAlerta.tipo) || 0}}</span>
                                        <span 
                                            ng-repeat-start="alertaEfd in $ctrl.tiposAlertasGrupoEfd" 
                                            ng-if="$ctrl.alertasCount.get(alertaEfd.tipo)" 
                                            class="text-muted">
                                            {{alertaEfd.descricao}} 
                                        </span>
                                        <span ng-repeat-end> </span>
                                    </div>
                                </div>
                            </promise-tracker>
                        </div>

                        <div ng-if="$ctrl.isAlertasEfdEnabled">
                            <div class="row">
                                <div class="form-group col-sm-4 col-md-2 col-lg-2">
                                    <label>
                                        Tipo do documento
                                    </label>
                                    <select class="form-control" ng-model="$ctrl.documentoFilter.tipo">
                                        <option value="nfe">NF-e (XML)</option>
                                        <option value="cte">CT-e (XML)</option>
                                        <option value="notaFiscal">Nota Fiscal (EFD)</option>
                                    </select>
                                </div>

                                <div class="form-group col-sm-8 col-md-4 col-lg-4">
                                    <label>
                                        Número
                                        <i class="fa fa-trash-o text-danger cursor-pointer" 
                                            ng-click="$ctrl.documentoFilter.numero = undefined"
                                            ng-if="$ctrl.documentoFilter.numero"></i>
                                    </label>
                                    <input type="text" class="form-control" 
                                            ng-model="$ctrl.documentoFilter.numero" 
                                            ng-model-options="{ debounce: 500 }">
                                </div>
                                
                                <div class="form-group col-sm-12 col-md-6 col-lg-6">
                                    <label>
                                        Chave
                                        <i class="fa fa-trash-o text-danger cursor-pointer" 
                                        ng-click="$ctrl.documentoFilter.chave = undefined"
                                        ng-if="$ctrl.documentoFilter.chave"></i>
                                    </label>
                                    <input type="text" class="form-control" 
                                            ng-model="$ctrl.documentoFilter.chave" 
                                            ng-model-options="{ debounce: 500 }">
                                </div>

                                <div ng-if="$ctrl.documentoFilter.tipo != 'notaFiscal'">
                                    <div class="form-group col-sm-3 col-md-2 col-lg-2">
                                        <label>
                                            Tipo do Participante
                                        </label>
                                        <select class="form-control" ng-model="$ctrl.participanteFilter.tipo">
                                            <option value="emitente">Emitente</option>
                                            <option value="destinatario">Destinatario</option>
                                        </select>
                                    </div>
                                    <div ng-if="$ctrl.participanteFilter.tipo" class="form-group col-sm-9 col-md-6 col-lg-6">
                                        <label>
                                            Busca do participante
                                            <i class="fa fa-trash-o text-danger cursor-pointer" 
                                            ng-click="$ctrl.participanteFilter.busca = undefined"
                                            ng-if="$ctrl.participanteFilter.busca"></i>
                                        </label>
                                        <input type="text" class="form-control" placeholder="Razão Social, CNPJ"
                                            ng-model="$ctrl.participanteFilter.busca" 
                                            ng-model-options="{ debounce: 500 }">
                                    </div>
                                </div>

                                <div class="col-xs-3">
                                    <label>&nbsp;</label>
                                    <button 
                                        class="btn btn-block btn-primary" 
                                        ng-click="$ctrl.refresh()"
                                        ng-disabled="$ctrl.isEmpty($ctrl.filter)">
                                        <i class="fa fa-refresh"></i> Atualizar
                                    </button>
                                </div>
                            </div>

                            <div>
                                <div 
                                    ng-repeat="(tipo, alertas) in $ctrl.alertasList" 
                                    ng-if="$ctrl.documentoFilter.numero || $ctrl.documentoFilter.chave">
                                    <div>
                                        <h3>{{$ctrl.getDescricaoTipoAlerta(tipo)}}</h3>
                                    </div>
                                    <loading promise="$ctrl.alertasPromise">
                                        <efd-alertas-list alertas="alertas" efd="$ctrl.efd"></efd-alertas-list>
                                    </loading>
                                </div>
                                <div ng-if="($ctrl.documentoFilter.numero || $ctrl.documentoFilter.chave || $ctrl.participanteFilter.busca) 
                                            && $ctrl.alertas.length == 0">
                                    <highlighted>
                                        <main>
                                            Nenhum alerta encontrado.
                                        </main>
                                        <secondary>
                                            Esta EFD não possui nenhum alerta para este filtro.
                                        </secondary>
                                    </highlighted>
                                </div>

                                <ef-collapse 
                                    ng-repeat="tipo in $ctrl.alertasFilteredCount" 
                                    is-collapsed="$ctrl.collapseStates[tipo]"
                                    ng-if="(!$ctrl.documentoFilter.numero && !$ctrl.documentoFilter.chave)"
                                    ng-click="$ctrl.switchAlerta(tipo, $ctrl.collapseStates[tipo])">
                                    <ef-collapse-header>
                                        <h3>{{$ctrl.getDescricaoTipoAlerta(tipo)}}</h3>
                                    </ef-collapse-header>

                                    <ef-collapse-content>
                                        <loading promise="$ctrl.alertasPromise" >
                                            <div ng-if="$ctrl.participanteFilter.busca">
                                                <highlighted ng-if="$ctrl.alertas.length == 0">
                                                    <main>
                                                        Nenhum alerta encontrado.
                                                    </main>
                                                    <secondary>
                                                        Esta EFD não possui nenhum alerta para este filtro.
                                                    </secondary>
                                                </highlighted>
                                            </div>

                                            <cursor-paginator
                                                ng-if="tipo == $ctrl.filter.tipoIs"
                                                per-page="10" 
                                                next-page="$ctrl.nextPage" 
                                                previous-page="$ctrl.previousPage"
                                                current-page="$ctrl.currentPage" 
                                                current-page-size="$ctrl.alertas.length" 
                                                on-change="$ctrl.pageChange($page)" 
                                                search-context="$ctrl.searchContext">
                                            </cursor-paginator>

                                            <efd-alertas-list alertas="$ctrl.alertas" efd="$ctrl.efd"></efd-alertas-list>

                                            <cursor-paginator
                                                ng-if="tipo == $ctrl.filter.tipoIs"
                                                per-page="10" 
                                                next-page="$ctrl.nextPage" 
                                                previous-page="$ctrl.previousPage"
                                                current-page="$ctrl.currentPage" 
                                                current-page-size="$ctrl.alertas.length" 
                                                on-change="$ctrl.pageChange($page)" 
                                                search-context="$ctrl.searchContext">
                                            </cursor-paginator>
                                        </loading>
                                    </ef-collapse-content>
                                </ef-collapse>
                            </div>
                        </div>
                    </ef-permissao-ferramenta>
                </loading>
            </div>
        `
    })
